import React from 'react';

import Image from '../../library/image/image';
import Flag from '../flag/flag';

import styles from './treadwell-rank-banner.scss';

interface TreadwellRankBannerProps {
  className?: string;
  hideLabel?: boolean;
  rank?: number;
}

function TreadwellRankBanner(props: TreadwellRankBannerProps) {
  const { className = '', hideLabel = false, rank } = props;
  return (
    <span className={`treadwell-rank-banner ${className}`}>
      <Flag className={styles['tw-rank']}>
        #{rank}
        {hideLabel && (
          <Image
            alt="Treadwell icon"
            className={styles['icon']}
            height="22"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark-on-white.svg"
          />
        )}
      </Flag>
      {!hideLabel && (
        <Flag
          className={styles['tw-text-flag']}
          renderIcon={
            <Image
              alt="Treadwell icon"
              height="22"
              src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark-on-white.svg"
            />
          }
        >
          {rank === 1 ? 'BEST MATCH' : 'RECOMMENDED'}
        </Flag>
      )}
    </span>
  );
}

export default TreadwellRankBanner;
